import { render, staticRenderFns } from "./FormTagsAdvanceCustom.vue?vue&type=template&id=459a7070&"
import script from "./FormTagsAdvanceCustom.vue?vue&type=script&lang=js&"
export * from "./FormTagsAdvanceCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports